// src/api/apiProductTypes.js
import axios from "../utils/axios";

/// Get Product Types
export const getAllProductTypes = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("product-types", { params });
    return data;
};

/// Get Product Types Enum Values for Select Dropdown
export const getProductTypesEnumValues = async () => {
    try {
        const { data } = await axios.get("product-types/enum-values");
        return data;
    } catch (error) {
        console.error("getProductTypesEnumValues error:", error);
        throw error;
    }
};

/// Get Product Type
export const getProductType = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`product-types/${id}`);
    return data;
};

/// Create Product Type
export const createProductType = async (req) => {
    try {
        const { data } = await axios.post("product-types", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createProductType error:", error);
        throw error;
    }
};

/// Update Product Type
export const updateProductType = async (req, id) => {
    try {
        const { data } = await axios.put(`product-types/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateProductType error:", error);
        throw error;
    }
};

/// Delete Product Type
export const deleteProductType = async (id) => {
    try {
        const { data } = await axios.delete(`product-types/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteProductType error:", error);
        throw error;
    }
};

/// Delete All Product Types
export const deleteAllProductTypes = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "product-types/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllProductTypes error:", error);
        throw error;
    }
};

/// Restore Product Type
export const restoreProductType = async (id) => {
    try {
        const { data } = await axios.post(`product-types/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreProductType error:", error);
        throw error;
    }
};

/// Restore multiple Product Types
export const restoreAllProductTypes = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "product-types/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllProductTypes error:", error);
        throw error;
    }
};

/// Force Delete Product Type
export const forceDeleteProductType = async (id) => {
    try {
        const { data } = await axios.delete(`product-types/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteProductType error:", error);
        throw error;
    }
};

/// Force Delete multiple Product Types
export const forceDeleteAllProductTypes = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "product-types/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllProductTypes error:", error);
        throw error;
    }
};

/// Get Product Types for Select Dropdown (optional, for future use)
export const getProductTypesForSelect = async () => {
    try {
        const { data } = await axios.get("product-types/for-select");
        return data;
    } catch (error) {
        console.error("getProductTypesForSelect error:", error);
        throw error;
    }
};